import * as _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { Redirect, BrowserRouter as Router, Switch } from 'react-router-dom'
import { login, startLogout } from '../actions/auth'
import { AuthRouter } from './AuthRouter'
import PrivateRoute from './PrivateRoute'
import PublicRoute from './PublicRoute'
import { firebase } from '../config/firebase-config'
import { useDispatch } from 'react-redux'
import WarehouseManagement from '../modules/WarehouseManagement'
import ReverseLogistic from '../modules/ReverseLogistic'
import Sidebar from '../components/Sidebar'
import FirstMile from '../modules/FirstMile'
import Movements from '../modules/ReverseLogistic/Movements'
import Processing from '../modules/ReverseLogistic/Processing'
import WmMovements from '../modules/WarehouseManagement/views/Movements'
import WmProcessing from '../modules/WarehouseManagement/views/Processing'
import ExternalCards from '../modules/WarehouseManagement/views/Movements/External/Cards'
import Planning from '../modules/Planning'
import Tools from '../modules/Tools'
import CierreConductores from '../modules/cierre'
import ControlGestion from '../modules/ControlGestion'
import ControlDiario from '../modules/ControlGestion/pages/ControlDiario'
import BusquedaGuias from '../modules/ControlGestion/pages/BusquedaGuias'
import ControlSemanal from '../modules/ControlGestion/pages/ControlSemanal'
import BusquedaMasivaGuias from '../modules/ControlGestion/pages/BusquedaMasivaGuias'
import RutasPendientesRevision from '../modules/ControlGestion/pages/RutasPendientesRevision'
import Mantenedores from '../modules/Mantenedores'
// Importar páginas específicas de mantenedores
import DirectorioLanding from '../modules/Mantenedores/pages/Directorio/Landing'
import Directorio from '../modules/Mantenedores/pages/Directorio'
import Conductores from '../modules/Mantenedores/pages/Directorio/Conductores'
import VehiculosPage from '../modules/Mantenedores/pages/Directorio/VehiculosPage'
import Empresas from '../modules/Mantenedores/pages/Empresas'
import EstadosSubestados from '../modules/Mantenedores/pages/EstadosSubestados'
import Extras from '../modules/Mantenedores/pages/Extras'
import Generales from '../modules/Mantenedores/pages/Generales'
import RutasConductores from '../modules/Mantenedores/pages/RutasConductores'
import Tarifarios from '../modules/Mantenedores/pages/Tarifarios'
import TarifarioCompleto from '../modules/Mantenedores/pages/Tarifarios/TarifarioCompleto'
import TarifarioEmpresas from '../modules/Mantenedores/pages/Tarifarios/TarifarioEmpresas'
import ErroresTarifarios from '../modules/Mantenedores/pages/Tarifarios/ErroresTarifarios'
import ErroresTarifariosDetallePage from '../modules/Mantenedores/pages/Tarifarios/ErroresTarifariosDetalle'
import ErroresTarifariosEmpresaPage from '../modules/Mantenedores/pages/Tarifarios/ErroresTarifariosEmpresa'
import Usuarios from '../modules/Mantenedores/pages/Usuarios'
import Cierre from '../modules/Mantenedores/pages/Cierre'
import CierreDiaADia from '../modules/Mantenedores/pages/Cierre/DiaADia'
import CierreAcumulado from '../modules/Mantenedores/components/Cierre/CierreAcumulado'
import ListaExtras from '../modules/Mantenedores/pages/Extras/Lista'
import AsignacionesExtras from '../modules/Mantenedores/pages/Extras/Asignaciones'
import TipoFlota from '../modules/Mantenedores/pages/Generales/TipoFlota'
import CentroDespachos from '../modules/Mantenedores/pages/Generales/CentroDespachos'
import TMS from '../modules/Mantenedores/pages/Generales/TMS'
import TiposDocumento from '../modules/Mantenedores/pages/Generales/TiposDocumento'
// Nuevos submenús generales
import Regiones from '../modules/Mantenedores/pages/Generales/Regiones'
import Comunas from '../modules/Mantenedores/pages/Generales/Comunas'
import TamanoSpread from '../modules/Mantenedores/pages/Generales/TamanoSpread'
import LocalCliente from '../modules/Mantenedores/pages/Generales/LocalCliente'
import TamanoCliente from '../modules/Mantenedores/pages/Generales/TamanoCliente'
import Banco from '../modules/Mantenedores/pages/Generales/Banco'
import TipoCuenta from '../modules/Mantenedores/pages/Generales/TipoCuenta'
import ServicioSpread from '../modules/Mantenedores/pages/Generales/ServicioSpread'
import Clientes from '../modules/Mantenedores/pages/Generales/Clientes'
// Componente de prueba para API
import TestApiConnection from '../modules/Mantenedores/components/TestApiConnection'
import SimpleApiTest from '../modules/Mantenedores/components/SimpleApiTest'
import TestUsuario from '../modules/Mantenedores/components/TestUsuario'
// import Sorting from '../modules/Sorting'
import { ExternalReturnUndeliveredNew, ExternalReturnUndeliveredResume, ExternalReturnUndeliveredFinished } from '../modules/WarehouseManagement/views/Movements/External/ReturnUndelivered'
import { ReturnDispatchRouteNew, ReturnDispatchRouteResume, ReturnDispatchRouteFinished } from '../modules/WarehouseManagement/views/Movements/External/ReturnDispatchRoute'
// import Manifest from '../modules/Planning/Manifest'
// import Sectorizer from '../modules/Planning/Sectorizer'
import { useSelector } from 'react-redux'
import MantenedoresRouteWrapper from '../modules/Mantenedores/context/MantenedoresRouteWrapper'

import Tablesview from '../components/Tables/TablesView/Tablesview'
import FormView from '../components/Forms/FormView/FormView'
import CierreMensualPage from 'modules/Mantenedores/pages/Cierre/CierreMensual'
import EmailTemplatesPage from 'modules/Mantenedores/pages/Cierre/EmailTemplates'
import EmailTemplateEditor from 'modules/Mantenedores/pages/Cierre/EmailTemplates/EmailTemplateEditor'

const fieldsToGet = ['displayName', 'emailVerified', 'email', 'phoneNumber', 'photoURL', 'uid', 'refreshToken']

const RouterComponent = () => {
    const lastPath = localStorage.getItem('lastPath') || '/auth'

    const dispatch = useDispatch()
    const [checking, setChecking] = useState(true)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const { user: currentUser } = useSelector(state => state.auth)

    useEffect(() => {
        firebase.auth().onAuthStateChanged(user => {
            if (user?.uid && user.email.includes('@spread.cl')) {
                const currentUser = _.pick(user, fieldsToGet)
                dispatch(login(currentUser))
                setIsLoggedIn(true)
            } else {
                setIsLoggedIn(false)
                dispatch(startLogout())
            }

            setChecking(false)
        })
    }, [dispatch, setChecking, setIsLoggedIn])

    if (checking) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                {/* <h1>Cargando...</h1> */}
            </div>
        )
    }

    return (
        <Router>
            {isLoggedIn ? <Sidebar /> : ''}
            <main role='main' className={isLoggedIn ? 'main-with-sidebar' : 'w-100'} style={{
                minHeight: '100vh',
                overflowX: 'hidden',
                overflowY: 'auto'
            }}>
                <Switch>
                    <PublicRoute isAuthenticated={isLoggedIn} path="/auth" component={AuthRouter} />
                    {/* <PrivateRoute exact 
                        path="/dashboard" 
                        isAuthenticated={isLoggedIn} 
                        component={Dashboard}
                    />
                    <PrivateRoute exact 
                        path="/sorting" 
                        isAuthenticated={isLoggedIn} 
                        component={Sorting}
                    />*/}
                    <PrivateRoute exact
                        path="/first-mile"
                        isAuthenticated={isLoggedIn}
                        component={FirstMile}
                    />
                    <PrivateRoute exact
                        path="/planning"
                        isAuthenticated={isLoggedIn}
                        component={Planning}
                    />
                    <PrivateRoute exact
                        path="/cierre"
                        isAuthenticated={isLoggedIn}
                        component={CierreConductores}
                    />
                    {/* sorting module */}
                    {/* <PrivateRoute exact 
                        path="/planning/sectorizer" 
                        isAuthenticated={isLoggedIn} 
                        component={Sectorizer}
                    /> */}
                    {/*
                    <PrivateRoute exact 
                        path="/dispatch" 
                        isAuthenticated={isLoggedIn} 
                        component={Dispatch}
                    />*/}
                    <PrivateRoute exact
                        path="/wms"
                        isAuthenticated={isLoggedIn}
                        component={WarehouseManagement}
                    />
                    <PrivateRoute exact
                        path="/wms/movements"
                        isAuthenticated={isLoggedIn}
                        component={WmMovements}
                    />
                    <PrivateRoute exact
                        path="/wms/movements/external"
                        isAuthenticated={isLoggedIn}
                        component={ExternalCards}
                    />
                    <PrivateRoute exact
                        path="/wms/movements/external/undelivered-return"
                        isAuthenticated={isLoggedIn}
                        component={ExternalReturnUndeliveredResume}
                    />
                    <PrivateRoute exact
                        path="/wms/movements/external/undelivered-return/new"
                        isAuthenticated={isLoggedIn}
                        component={ExternalReturnUndeliveredNew}
                    />
                    <PrivateRoute exact
                        path="/wms/movements/external/undelivered-return/success"
                        isAuthenticated={isLoggedIn}
                        component={ExternalReturnUndeliveredFinished}
                    />
                    <PrivateRoute exact
                        path="/wms/movements/external/return-dispatch-route"
                        isAuthenticated={isLoggedIn}
                        component={ReturnDispatchRouteResume}
                    />
                    <PrivateRoute exact
                        path="/wms/movements/external/return-dispatch-route/new"
                        isAuthenticated={isLoggedIn}
                        component={ReturnDispatchRouteNew}
                    />
                    <PrivateRoute exact
                        path="/wms/movements/external/return-dispatch-route/success"
                        isAuthenticated={isLoggedIn}
                        component={ReturnDispatchRouteFinished}
                    />
                    <PrivateRoute exact
                        path="/wms/processing"
                        isAuthenticated={isLoggedIn}
                        component={WmProcessing}
                    />
                    <PrivateRoute exact
                        path="/reverse-logistic"
                        isAuthenticated={isLoggedIn}
                        component={ReverseLogistic}
                    />
                    <PrivateRoute exact
                        path="/reverse-logistic/movements"
                        isAuthenticated={isLoggedIn}
                        component={Movements}
                    />
                    <PrivateRoute exact
                        path="/reverse-logistic/processing"
                        isAuthenticated={isLoggedIn}
                        component={Processing}
                    />
                    <PrivateRoute exact
                        path="/tools"
                        isAuthenticated={isLoggedIn}
                        component={Tools}
                    />
                    <PrivateRoute exact
                        path="/mantenedores"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Mantenedores} {...props} />}
                    />
                    {/* Rutas específicas de mantenedores */}
                    <PrivateRoute exact
                        path="/mantenedores/cierre"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Cierre} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/cierre/dia-a-dia"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={CierreDiaADia} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/cierre/acumulado"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={CierreAcumulado} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/cierre/cierre-mensual"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={CierreMensualPage} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/cierre/email-templates"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={EmailTemplatesPage} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/cierre/email-templates/nuevo"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={EmailTemplateEditor} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/cierre/email-templates/:id"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={EmailTemplateEditor} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/directorio"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={DirectorioLanding} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/directorio/conductores"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Conductores} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/directorio/vehiculos"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={VehiculosPage} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/empresas"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Empresas} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/estados"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={EstadosSubestados} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/extras"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Extras} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/extras/lista"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={ListaExtras} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/extras/asignaciones"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={AsignacionesExtras} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Generales} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/tipo-flota"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={TipoFlota} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/centro-despachos"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={CentroDespachos} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/tms"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={TMS} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/tipos-documento"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={TiposDocumento} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/regiones"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Regiones} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/comunas"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Comunas} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/tamano-spread"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={TamanoSpread} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/local-cliente"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={LocalCliente} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/tamano-cliente"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={TamanoCliente} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/banco"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Banco} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/tipo-cuenta"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={TipoCuenta} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/servicio-spread"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={ServicioSpread} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/generales/clientes"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Clientes} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/rutas"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={RutasConductores} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/tarifarios"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Tarifarios} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/tarifarios/completo"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={TarifarioCompleto} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/tarifarios/empresas"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={TarifarioEmpresas} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/tarifarios/errores"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={ErroresTarifarios} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/tarifarios/errores/empresa"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={ErroresTarifariosEmpresaPage} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/tarifarios/errores/:tipoTarifarioId"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={ErroresTarifariosDetallePage} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/mantenedores/usuarios"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={Usuarios} {...props} />}
                    />
                    {/* Ruta temporal para probar API de permisos */}
                    <PrivateRoute exact
                        path="/mantenedores/test-api"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={TestApiConnection} {...props} />}
                    />
                    {/* Ruta para test simple de API */}
                    <PrivateRoute exact
                        path="/mantenedores/simple-test"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={SimpleApiTest} {...props} />}
                    />
                    {/* Ruta para test de usuarios con estructura ControlGestion */}
                    <PrivateRoute exact
                        path="/mantenedores/test-usuario"
                        isAuthenticated={isLoggedIn}
                        component={props => <MantenedoresRouteWrapper Component={TestUsuario} {...props} />}
                    />
                    <PrivateRoute exact
                        path="/control-gestion"
                        isAuthenticated={isLoggedIn}
                        component={ControlGestion}
                    />
                    <PrivateRoute exact
                        path="/control-gestion/control-diario"
                        isAuthenticated={isLoggedIn}
                        component={ControlDiario}
                    />
                    <PrivateRoute exact
                        path="/control-gestion/busqueda-guias"
                        isAuthenticated={isLoggedIn}
                        component={BusquedaGuias}
                    />
                    <PrivateRoute exact
                        path="/control-gestion/control-semanal"
                        isAuthenticated={isLoggedIn}
                        component={ControlSemanal}
                    />
                    <PrivateRoute exact
                        path="/control-gestion/busqueda-masiva-guias"
                        isAuthenticated={isLoggedIn}
                        component={BusquedaMasivaGuias}
                    />
                    <PrivateRoute exact
                        path="/control-gestion/rutas-pendientes-revision"
                        isAuthenticated={isLoggedIn}
                        component={RutasPendientesRevision}
                    />
                    <PrivateRoute exact
                        path="/test"
                        isAuthenticated={isLoggedIn}
                        component={Tablesview}
                    />
                    <PrivateRoute exact
                        path="/test2"
                        isAuthenticated={isLoggedIn}
                        component={FormView}
                    />
                    <Redirect to={lastPath} />
                </Switch>
            </main>
        </Router>
    )
}

export default RouterComponent